module.exports = __webpack_public_path__ + "img/m_Chop Shop.4113a258.png";